/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ApprovedSendersForTransitsSortField {
  PermissionNumber = 0,
  CompanyName = 1,
  Inactive = 2,
}
